var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('c-box', {
    attrs: {
      "as": "div",
      "pos": "relative",
      "w": "100%",
      "background-color": ['transparent', '#008C81'],
      "py": ['0px', '0px']
    }
  }, [_c('c-box', {
    attrs: {
      "w": "100%",
      "max-width": "1100px",
      "mx": "auto"
    }
  }, [!_vm.isLoading && _vm.filteredBanners.length > 0 ? _c('VueSlickCarousel', _vm._b({
    directives: [{
      name: "chakra",
      rawName: "v-chakra",
      value: {
        '.slick-prev': {
          width: '50px',
          height: '50px',
          left: '150px',
          backgroundImage: require('@/assets/icon_next_left.svg'),
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100%',
          zIndex: '1',
          '::before': {
            display: 'none'
          },
          ':focus': {
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
            width: '50px',
            height: '50px',
            backgroundImage: require('@/assets/icon_next_left.svg')
          },
          ':hover': {
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
            width: '50px',
            height: '50px',
            backgroundImage: require('@/assets/icon_next_left.svg')
          },
          '@media(max-width: 767px)': {
            display: 'none !important'
          }
        },
        '.slick-next': {
          right: '150px',
          width: '50px',
          height: '50px',
          backgroundImage: require('@/assets/icon_next_right.svg'),
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100%',
          zIndex: '1',
          '::before': {
            display: 'none'
          },
          ':focus': {
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
            width: '50px',
            height: '50px',
            backgroundImage: require('@/assets/icon_next_right.svg')
          },
          ':hover': {
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
            width: '50px',
            height: '50px',
            backgroundImage: require('@/assets/icon_next_right.svg')
          },
          '@media(max-width: 767px)': {
            display: 'none !important'
          }
        },
        '.slick-dots': {
          bottom: '8px',
          '@media(max-width: 767px)': {
            bottom: '15px'
          },
          li: {
            '@media(max-width: 767px)': {
              margin: '0 3px'
            },
            button: {
              '::before': {
                fontSize: '12px',
                color: '#FFFFFF',
                opacity: '1',
                '@media(max-width: 767px)': {
                  fontSize: '10px'
                }
              }
            },
            '&.slick-active': {
              button: {
                '::before': {
                  color: '#F4CC46',
                  opacity: '1'
                }
              }
            }
          }
        },
        '.slick-slide': {
          padding: '0 8px',
          transform: 'scale(0.9)',
          transitionProperty: 'all',
          transitionDuration: '300ms',
          transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
          '@media(max-width: 767px)': {
            padding: '0px',
            transform: 'none'
          }
        },
        '.slick-slide.slick-current': {
          transform: ['scale(1)', 'scale(1.1)'],
          '@media(max-width: 767px)': {
            transform: 'none'
          }
        }
      },
      expression: "{\n        '.slick-prev': {\n          width: '50px',\n          height: '50px',\n          left: '150px',\n          backgroundImage: require('@/assets/icon_next_left.svg'),\n          backgroundRepeat: 'no-repeat',\n          backgroundSize: '100%',\n          zIndex: '1',\n          '::before': {\n            display: 'none',\n          },\n          ':focus': {\n            backgroundRepeat: 'no-repeat',\n            backgroundSize: '100%',\n            width: '50px',\n            height: '50px',\n            backgroundImage: require('@/assets/icon_next_left.svg'),\n          },\n          ':hover': {\n            backgroundRepeat: 'no-repeat',\n            backgroundSize: '100%',\n            width: '50px',\n            height: '50px',\n            backgroundImage: require('@/assets/icon_next_left.svg'),\n          },\n          '@media(max-width: 767px)': {\n            display: 'none !important',\n          },\n        },\n        '.slick-next': {\n          right: '150px',\n          width: '50px',\n          height: '50px',\n          backgroundImage: require('@/assets/icon_next_right.svg'),\n          backgroundRepeat: 'no-repeat',\n          backgroundSize: '100%',\n          zIndex: '1',\n          '::before': {\n            display: 'none',\n          },\n          ':focus': {\n            backgroundRepeat: 'no-repeat',\n            backgroundSize: '100%',\n            width: '50px',\n            height: '50px',\n            backgroundImage: require('@/assets/icon_next_right.svg'),\n          },\n          ':hover': {\n            backgroundRepeat: 'no-repeat',\n            backgroundSize: '100%',\n            width: '50px',\n            height: '50px',\n            backgroundImage: require('@/assets/icon_next_right.svg'),\n          },\n          '@media(max-width: 767px)': {\n            display: 'none !important',\n          },\n        },\n        '.slick-dots': {\n          bottom: '8px',\n          '@media(max-width: 767px)': {\n            bottom: '15px',\n          },\n          li: {\n            '@media(max-width: 767px)': {\n              margin: '0 3px',\n            },\n            button: {\n              '::before': {\n                fontSize: '12px',\n                color: '#FFFFFF',\n                opacity: '1',\n                '@media(max-width: 767px)': {\n                  fontSize: '10px',\n                },\n              },\n            },\n            '&.slick-active': {\n              button: {\n                '::before': {\n                  color: '#F4CC46',\n                  opacity: '1',\n                },\n              },\n            },\n          },\n        },\n        '.slick-slide': {\n          padding: '0 8px',\n          transform: 'scale(0.9)',\n          transitionProperty: 'all',\n          transitionDuration: '300ms',\n          transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',\n          '@media(max-width: 767px)': {\n            padding: '0px',\n            transform: 'none',\n          },\n        },\n        '.slick-slide.slick-current': {\n          transform: ['scale(1)', 'scale(1.1)'],\n          '@media(max-width: 767px)': {\n            transform: 'none',\n          },\n        },\n      }"
    }]
  }, 'VueSlickCarousel', _vm.settings, false), _vm._l(_vm.filteredBanners, function (item, index) {
    return _c('c-box', {
      key: 'banner-' + index,
      staticClass: "item",
      attrs: {
        "as": "a",
        "target": "_blank",
        "pos": "relative",
        "max-height": "500px",
        "mx": "auto",
        "mt": ['0px', '30px'],
        "mb": [_vm.isAuthenticated ? '-7px' : '0px', '50px']
      },
      on: {
        "click": function click($event) {
          return _vm.handleClick(item);
        }
      }
    }, [_c('c-image', {
      attrs: {
        "src": item.image,
        "srcset": item.image,
        "alt": "dietela",
        "w": "auto",
        "height": ['auto', '360px'],
        "border-radius": ['0px', '24px'],
        "box-shadow": ['none', '0px 4px 8px rgba(0, 0, 0, 0.2)']
      }
    })], 1);
  }), 1) : _c('c-box', [_c('SkeletonBanner')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }